import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-empty',
    templateUrl: './empty.component.html',
})
export class EmptyComponent extends Block {

}
